import React, { useState, useEffect, useRef } from 'react';

const CoursesSection = () => {

    const courses = [
        {
            id: 1,
            title: "Micropigmentación de Cejas, Labios y Ojos",
            description: "Domina la técnica más buscada en el mundo de la estética. Aprendé a embellecer rostros con precisión, seguridad y resultados naturales.",
            image: require('../assets/imagenes/cursos/curso1.jpg'),
            color: "primary"
        },
        {
            id: 2,
            title: "Formación Integral en Cosmetología, Cosmiatría y Dermocosmiatría",
            description: "Convertite en una experta en el cuidado y tratamiento de la piel. Aprendé desde las bases estéticas hasta las técnicas más avanzadas para abordar imperfecciones, potenciar la belleza y brindar resultados reales.",
            image: require('../assets/imagenes/cursos/curso2.jpg'),
            color: "secondary"
        },
        {
            id: 3,
            title: "Estética de Pies Profesional con Esmaltado Semipermanente",
            description: "Aprendé a realizar tratamientos completos de embellecimiento podal. Combiná técnicas de higiene profunda con esmaltado semipermanente para ofrecer un servicio estético, seguro y de alta demanda.",
            image: require('../assets/imagenes/cursos/curso3.jpg'),
            color: "primary"
        },
        {
            id: 4,
            title: "Masaje Corporal Intensivo – 4 Técnicas en una Formación",
            description: "Aprendé a aplicar técnicas de masaje corporal que te permitirán mejorar la circulación sanguínea, reducir la tensión muscular y promover la relajación general.",
            image: require('../assets/imagenes/cursos/curso4.jpg'),
            color: "secondary"
        },
        {
            id: 5,
            title: "Maderoterapia Facial y Corporal + Piedras Calientes",
            description: "Aprendé a trabajar el rostro y el cuerpo con herramientas de madera y piedras calientes para potenciar resultados y brindar una experiencia única.",
            image: require('../assets/imagenes/cursos/curso5.jpg'),
            color: "primary"
        },
        {
            id: 6,
            title: "Maquillaje Profesional",
            description: "Descubrí el mundo del maquillaje desde cero o perfeccioná tu técnica. Aprendé paso a paso cómo realzar la belleza con herramientas y conocimientos profesionales",
            image: require('../assets/imagenes/cursos/curso6.jpg'),
            color: "secondary"
        },
        {
            id: 7,
            title: "Depilación Definitiva",
            description: "Aprendé a aplicar tecnología en depilación definitiva con enfoque seguro, eficaz y rentable. Capacitate para ofrecer uno de los servicios más demandados en estética actual.",
            image: require('../assets/imagenes/cursos/curso7.jpg'),
            color: "primary"
        },
        {
            id: 8,
            title: "Extensión y Volumen de Pestañas",
            description: "Aprendé las técnicas para aplicar extensiones de pestañas con diseño, precisión y volumen. Ofrecé un servicio estético de alto impacto y gran demanda",
            image: require('../assets/imagenes/cursos/curso8.jpg'),
            color: "secondary"
        },
        {
            id: 9,
            title: "Tratamientos Faciales Avanzados (Dermapen, BB Glow, Hidrolips, Hilos Tensores)",
            description: "Capacitate en las técnicas faciales más innovadoras y solicitadas del sector estético: Dermapen, BB Glow, Hidrolips e Hilos Tensores de Colágeno. Aprendé a trabajar la piel desde el rejuvenecimiento, la hidratación profunda y la bioregeneración no invasiva.",
            image: require('../assets/imagenes/cursos/curso9.jpg'),
            color: "primary"
        },
        {
            id: 10,
            title: "Tratamientos con Exosomas y PDRN de Salmón",
            description: "Formate en tratamientos regenerativos de última generación. Aprendé a aplicar exosomas y PDRN de salmón para estimular la reparación celular, mejorar la calidad de la piel y potenciar resultados visibles desde la primera sesión.",
            image: require('../assets/imagenes/cursos/curso10.jpg'),
            color: "secondary"
        },
        {
            id: 11,
            title: "Curso de Lifting de Pestañas, Laminado y Diseño de Cejas",
            description: "Aprendé las técnicas más demandadas para realzar la mirada: lifting de pestañas, laminado, diseño y perfilado de cejas. Ofrecé resultados naturales, duraderos y con alto valor estético.",
            image: require('../assets/imagenes/cursos/curso11.jpg'),
            color: "primary"
        },
        {
            id: 12,
            title: "Microblading",
            description: "Capacitate en una de las técnicas más precisas y rentables en diseño de cejas. Aprendé microblading desde cero o perfeccioná tu trazo para ofrecer resultados hiperrealistas y personalizados.",
            image: require('../assets/imagenes/cursos/curso12.jpg'),
            color: "secondary"
        },
        {
            id: 13,
            title: "Curso de Asesoría de Imagen Profesional",
            description: "Formate como asesora de imagen y aprendé a potenciar la estética personal desde el estilo, el color y la identidad. Descubrí cómo guiar a tus clientas en su expresión visual con confianza y coherencia.",
            image: require('../assets/imagenes/cursos/curso13.jpg'),
            color: "primary"
        },
        {
            id: 14,
            title: "Curso Profesional de Uñas Acrílicas, Polygel y Softgel",
            description: "Aprendé las técnicas más utilizadas en el mundo de las uñas esculpidas. Dominá acrílico, polygel y softgel para crear estructuras duraderas, estéticas y 100% personalizadas.",
            image: require('../assets/imagenes/cursos/curso14.jpg'),
            color: "secondary"
        },
        {
            id: 15,
            title: "Curso de Manicura Tradicional, Kapping y Esmaltado Semipermanente",
            description: "Aprendé desde la base del cuidado de manos hasta las técnicas más buscadas en esmaltado duradero. Dominá manicura tradicional, kapping y semipermanente para ofrecer un servicio completo y profesional.",
            image: require('../assets/imagenes/cursos/curso15.jpg'),
            color: "primary"
        }
    ];

    const openWhatsApp = (courseName) => {
        const message = `Hola, me interesa el curso de ${courseName}. ¿Podrían brindarme más información sobre programa académico y inversión?`;
        window.open(`https://wa.me/59894075255?text=${encodeURIComponent(message)}`, '_blank');
    };

    return (
        <section id="courses" className="py-20 bg-black relative overflow-hidden">
            {/* Simple Background Pattern */}
            <div className="absolute inset-0">
                <div className="absolute inset-0 bg-black"></div>
                <div className="absolute bottom-0 left-0 w-full h-2/3 bg-gradient-to-tr from-amber-900/20 to-transparent rounded-full blur-3xl"></div>
                <div className="absolute top-1/4 right-0 w-3/5 h-2/5 bg-gradient-to-bl from-amber-800/25 to-transparent rounded-full blur-2xl"></div>
            </div>

            <div className="max-w-7xl mx-auto px-6 relative z-10">
                {/* Header */}
                <div className={`text-center mb-16 transition-all duration-1000`}>
                    <span className="inline-block bg-primary text-white px-6 py-2 rounded-full text-sm font-medium mb-6">
                        Programas Académicos
                    </span>
                    <h2 className="text-4xl lg:text-5xl font-light text-white mb-4">
                        Nuestros <span className="text-primary">Cursos</span>
                    </h2>
                    <p className="text-lg text-gray-300 max-w-3xl mx-auto">
                        Formación profesional de calidad en estética y belleza
                    </p>
                </div>

                {/* Courses Grid */}
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {courses.map((course, index) => (
                        <div
                            key={course.id}
                            className={`bg-zinc-900/80 backdrop-blur-sm rounded-2xl overflow-hidden border border-zinc-700/50 hover:border-primary transition-all duration-500 hover:scale-105 flex flex-col h-full`}
                        >
                            {/* Image */}
                            <div className="relative h-48 overflow-hidden">
                                <img
                                    src={course.image}
                                    alt={course.title}
                                    className="w-full h-full object-cover"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                            </div>

                            {/* Content - Flex grow to push button down */}
                            <div className="p-6 flex flex-col flex-grow">
                                <h3 className="text-xl font-semibold text-white mb-3 leading-tight">
                                    {course.title}
                                </h3>

                                <p className="text-gray-300 text-sm leading-relaxed mb-6 flex-grow">
                                    {course.description}
                                </p>

                                {/* Button - Always at bottom */}
                                <button
                                    onClick={() => openWhatsApp(course.title)}
                                    className={`w-full py-3 px-6 rounded-xl font-medium transition-all duration-300 mt-auto ${course.color === 'primary'
                                        ? 'bg-primary hover:bg-primary-light text-white'
                                        : 'bg-secondary hover:bg-secondary-light text-black border border-zinc-600'
                                        }`}
                                >
                                    Más Información
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default CoursesSection; 